"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _PeoplesUploaded = _interopRequireDefault(require("@rsuite/icon-font/lib/people/PeoplesUploaded"));

// Generated by script, don't edit it please.
var PeoplesUploaded = (0, _createSvgIcon["default"])({
  as: _PeoplesUploaded["default"],
  ariaLabel: 'peoples uploaded',
  category: 'people',
  displayName: 'PeoplesUploaded'
});
var _default = PeoplesUploaded;
exports["default"] = _default;
module.exports = exports.default;